import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import DevCoachingSwitch from './DevCoachingSwitch';

const RoleBasedModules = ({ config = {} }) => {
  if (!config.showRoleBasedModules) {
    return null;
  }

  const { devCoaching } = config;

  return (
    <Flex direction='column'>
      <Text size='large' weight='500' mt='2rem' mb='1rem'>
        ROLE-BASED MODULES
      </Text>
      <DevCoachingSwitch config={devCoaching} />
    </Flex>
  );
};

export default RoleBasedModules;
